import { useLocation } from "react-router-dom";

import { Link } from "common/types/routing";

import { asLocation } from "seneca-common/utils/routing";

import { FeedbackParamKey } from "../consts";

type Options = {
  location?: Link;
};

export function useFeedbackLink({ location }: Options = {}) {
  const locationFromContext = useLocation();

  const baseLocation = asLocation(location) || locationFromContext;

  const params = new URLSearchParams(baseLocation && baseLocation.search);
  params.set(FeedbackParamKey, "true");

  return {
    ...baseLocation,
    search: params.toString()
  };
}
